import { AbapQueryDetailsFragment } from 'generated/graphql';
import { UpdateABAPQueryState } from 'stores/interfaces/UpdateQueryState';
import { SetState } from 'zustand';

export const createUpdateABAPQuerySlice = (set: SetState<UpdateABAPQueryState>) => ({
  setInitialStateWithProps: (queryDetails: AbapQueryDetailsFragment) =>
    set({
      system: queryDetails.system,
      objectType: queryDetails.objectType,
      objectName: queryDetails.objectName,
      objectOwner: queryDetails.objectOwner,
      collectionPackage: queryDetails.collectionPackage,
      collectionOwner: queryDetails.collectionOwner,
      applicationComponent: queryDetails.applicationComponent,
      repositoryProgramType: queryDetails.repositoryProgramType,
      repositoryProgramId: queryDetails.repositoryProgramId,
      repositoryProgramName: queryDetails.repositoryProgramName,
      translationArea: queryDetails.translationArea,
      maxLength: queryDetails.maxLength
    })
});
